import axios from 'axios';
import router from '../routes';
import helpers from "../helpers";
import store from '../stores';

var url_api = "";//process.env.VUE_APP_URL_API + "/api";

var api = axios.create({
    //baseURL: url_api,
    responseType: 'json',
});

helpers.getEnv().then(async (env) => {
    url_api = await env.VUE_APP_URL_API + "/api";
    api.defaults.baseURL = url_api;
});

var filaRequisicoes = [];



api.interceptors.request.use((config) => {

    if (store.getters.isAuthenticated) {
        return store.dispatch("REFRESH_TOKEN")
            .then(() => {
                config.headers.Authorization = 'Bearer ' + store.getters.token;

                if (config.baseURL == url_api) {
                    //O loading sera controlado por uma fila, de forma ele sera exibido enquanto existir requisicoes na fila para processar
                    filaRequisicoes.push(config);
                    router.app.carregando = true;
                }

                return config;
            }).catch(() => {
                store.dispatch('LOGOUT_REQUEST')
            });
    } else {
        config.headers.Authorization = 'Bearer ' + store.getters.token;

        if (config.baseURL == url_api) {
            //O loading sera controlado por uma fila, de forma ele sera exibido enquanto existir requisicoes na fila para processar
            filaRequisicoes.push(config);
            router.app.carregando = true;
        }

        return config;
    }
});


api.interceptors.response.use(
    (response) => {
        if (response.config.baseURL == url_api) {
            //...apenas será invisivel quando a fila estiver esvaziada...
            if (filaRequisicoes.length > 0)
                filaRequisicoes.splice(0, 1);

            if (filaRequisicoes.length <= 0)
                router.app.carregando = false;
        }
        return response;
    },
    (error) => {
        filaRequisicoes.length = [];
        router.app.carregando = false;

        return Promise.reject(error);
    }
);

export default api;